var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"value":_vm.selected,"options":_vm.options,"placeholder":_vm.placeholder},on:{"input":_vm.change},scopedSlots:_vm._u([{key:"option",fn:function(ref){
var label = ref.label;
var object = ref.object;
return [_c('div',[_vm._v(_vm._s(label))]),_vm._v(" "),(object.type === 'job')?_c('em',[_vm._v("Scorecard da vaga")]):_vm._e()]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6de9726","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/SelectAvalibleScoreform.vue
// module id = null
// module chunks = 